var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetailorsSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 1.44309C10.919 1.44309 11.8003 1.80269 12.4501 2.44278C13.1 3.08288 13.465 3.95103 13.465 4.85626V5.5389H6.53493V4.85626C6.53493 3.95103 6.9 3.08288 7.54982 2.44278C8.19964 1.80269 9.08099 1.44309 9.99998 1.44309ZM14.851 5.5389V4.85626C14.851 3.58894 14.3399 2.37353 13.4302 1.47739C12.5204 0.581261 11.2866 0.0778198 9.99998 0.0778198C8.7134 0.0778198 7.47951 0.581261 6.56976 1.47739C5.66001 2.37353 5.14891 3.58894 5.14891 4.85626V5.5389H0.297852V19.1916C0.297852 19.9158 0.589905 20.6103 1.10976 21.1224C1.62962 21.6345 2.3347 21.9221 3.06989 21.9221H16.9301C17.6653 21.9221 18.3703 21.6345 18.8902 21.1224C19.4101 20.6103 19.7021 19.9158 19.7021 19.1916V5.5389H14.851Z",
    fill: "#FF855F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailorsSelected);
export default __webpack_public_path__ + "static/media/retailorsSelected.46f0920201318a6acf921188158ccce6.svg";
export { ForwardRef as ReactComponent };